import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
const callToActionData = {
    title: "What we really can guarantee for you",
    subtitle: "IEEE ISSAT Sousse Student Branch",
    disc:"IEEE ISSAT Sousse Student branch was approved by IEEE on the 4th of February 2015. At the beginning, it was formed by 17 members. So far we are about 170 members and we are willing to reach 220 members by 2022. Our targets are so diverse like Robotics, Automation, Energy, Computer Science ... That's why we have established many chapters in those domains such as RAS SBC, IAS SBC, CS SBC, PES SBC... And finally we should not forget our affinity group WIE SAG that represents the women engineers in our SB. IEEE ISSATSo and its members inspire the local community to innovate for a better tomorrow through highly cited publications, conferences, professional and educational activities. IEEE's core purpose is to foster technological innovation and excellence for the benefit of humanity. IEEE will be essential to the global technical community and to technical professionals everywhere and be universally recognized for the contributions of technology and of technical professionals in improving global conditions. "
}

const CalltoActionFive = () => {
    return (
        <div className="rn-callto-action clltoaction-style-default style-5">
            <div className="container">
                <div className="row row--2 align-items-center content-wrapper theme-shape">
                    <div className="col-lg-12">
                        <div className="inner">
                            <div className="content text-center">
                                <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                    <h2 className="title">{callToActionData.title}</h2>
                                </ScrollAnimation>
                                <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                    <h6 className="subtitle">{callToActionData.subtitle}</h6>
                                </ScrollAnimation>
                                <div className="col-lg-centre col-md-centre col-centre">
                                <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                    <p>{callToActionData.disc}</p>
                                </ScrollAnimation>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div>
                    
                    <br />
                </div>
        </div>
        
    )
}
export default CalltoActionFive;